import {
  START_GET_REPEAT_ORDER_LIST,
  SUCCESS_GET_REPEAT_ORDER_LIST,
  ERROR_GET_REPEAT_ORDER_LIST,
  START_DELETE_REPEAT_ORDER,
  SUCCESS_DELETE_REPEAT_ORDER,
  ERROR_DELETE_REPEAT_ORDER,
  START_REPEAT_ORDER_PATIENT_FIELD_LIST,
  SUCCESS_REPEAT_ORDER_PATIENT_FIELD_LIST,
  ERROR_REPEAT_ORDER_PATIENT_FIELD_LIST,
  START_CREATE_REPEAT_ORDER,
  SUCCESS_CREATE_REPEAT_ORDER,
  ERROR_CREATE_REPEAT_ORDER,
  START_UPDATE_REPEAT_ORDER,
  SUCCESS_UPDATE_REPEAT_ORDER,
  ERROR_UPDATE_REPEAT_ORDER,
  START_GET_SINGLE_REPEAT_ORDER,
  SUCCESS_GET_SINGLE_REPEAT_ORDER,
  ERROR_GET_SINGLE_REPEAT_ORDER,
  START_GET_SEARCH_REPEAT_ORDER,
  SUCCESS_GET_SEARCH_REPEAT_ORDER,
  ERROR_GET_SEARCH_REPEAT_ORDER,
  START_UPDATE_REPEAT_ORDER_DATE,
  SUCCESS_UPDATE_REPEAT_ORDER_DATE,
  ERROR_UPDATE_REPEAT_ORDER_DATE,
  START_UPDATE_GLOBAL_SETTING,
  SUCCESS_UPDATE_GLOBAL_SETTING,
  ERROR_UPDATE_GLOBAL_SETTING,
  START_GET_PRINT_REPEAT_ORDER_LIST,
  SUCCESS_GET_PRINT_REPEAT_ORDER_LIST,
  ERROR_GET_PRINT_REPEAT_ORDER_LIST,
  START_UPDATE_REPEAT_ORDER_NOTE,
  SUCCESS_UPDATE_REPEAT_ORDER_NOTE,
  ERROR_UPDATE_REPEAT_ORDER_NOTE,
  START_DELETE_REPEAT_ORDER_NOTE,
  SUCCESS_DELETE_REPEAT_ORDER_NOTE,
  ERROR_DELETE_REPEAT_ORDER_NOTE,
  START_GET_OOS_ORDER,
  SUCCESS_GET_OOS_ORDER,
  ERROR_GET_OOS_ORDER,
  START_GLOBAL_SETTING,
  SUCCESS_GLOBAL_SETTING,
  ERROR_GLOBAL_SETTING,
  START_CREATE_MULTI_ORDER,
  SUCCESS_CREATE_MULTI_ORDER,
  ERROR_CREATE_MULTI_ORDER,
  START_PRN_DRUG,
  SUCCESS_PRN_DRUG,
  ERROR_PRN_DRUG,
  SUCCESS_GLOBAL_SETTING_ACCESS,
  ERROR_GLOBAL_SETTING_ACCESS,
  START_GLOBAL_SETTING_ACCESS,
  START_PATIENT_MULTI_ORDER,
  SUCCESS_PATIENT_MULTI_ORDER,
  ERROR_PATIENT_MULTI_ORDER,
  SUCCESS_NEXT_ORDER_CYCLE,
  ERROR_NEXT_ORDER_CYCLE,
  START_NEXT_ORDER_CYCLE,
  SUCCESS_ORDER_COUNT_TYPE,
  ERROR_ORDER_COUNT_TYPE,
  START_ORDER_COUNT_TYPE,
  START_BULK_ORDER_COUNT,
  SUCCESS_BULK_ORDER_COUNT,
  ERROR_BULK_ORDER_COUNT,
  START_GET_BULK_ORDER_LIST,
  SUCCESS_GET_BULK_ORDER_LIST,
  ERROR_GET_BULK_ORDER_LIST,
  START_CREATE_BULK_ORDERS,
  SUCCESS_CREATE_BULK_ORDERS,
  ERROR_CREATE_BULK_ORDERS,
} from "Actions/RepeatOrderAction";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  getRepeatOrderListAPI,
  deleteRepeatOrderAPI,
  getRepeatOrderPatientListAPI,
  createRepeatOrderAPI,
  updateRepeatOrderAPI,
  getSingleRepeatOrder,
  getSearchRepeatOrder,
  updateDateAPI,
  updateGlobalSettingAPI,
  updateRepeatOrderNoteAPI,
  deleteRepeatOrderNoteAPI,
  getOosOrderListAPI,
  globalSettingAPI,
  createMultiOrderAPI,
  statusUpdateAPI,
  updatePRNAPI,
  globalSettingAccessApi,
  patientMultiOrderAPI,
  nextOrderCycleAPI,
  orderCountTypeAPI,
  bulkOrderCountAPI,
  getBulkOrderListAPI,
  createBulkOrderAPI,
} from "Api/RepeatOrderApis";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { SUCCESS_STATUS_PATIENT_UPDATE } from "Actions/PatientAction";
import { Create_Bulk_Order_Today } from "Api/endpoints";

function* getRepeatOrderListWorker({ payload }) {
  try {
    const res = yield call(getRepeatOrderListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_REPEAT_ORDER_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_REPEAT_ORDER_LIST,
        payload: res,
      });
    }
  } catch (error) { }
}

function* getRepeatOrderPatientFieldListWorker({ payload }) {
  try {
    const res = yield call(getRepeatOrderPatientListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_REPEAT_ORDER_PATIENT_FIELD_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_REPEAT_ORDER_PATIENT_FIELD_LIST,
        payload: res,
      });
    }
  } catch (error) { }
}

function* deleteRepeatOrderWorker({ id }) {
  try {
    const res = yield call(deleteRepeatOrderAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_REPEAT_ORDER,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Order Deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_REPEAT_ORDER,
        payload: res,
      });
    }
  } catch (error) { }
}

function* createRepeatOrderWorker({ payload }) {
  try {
    const res = yield call(createRepeatOrderAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_REPEAT_ORDER,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Order Added Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_REPEAT_ORDER,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.errors["medication.0.id"][0],
          type: "error",
        },
      });
    }
  } catch (error) { }
}

function* updateRepeatOrderWorker({ id, payload }) {
  try {
    const res = yield call(updateRepeatOrderAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_REPEAT_ORDER,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Order Updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_REPEAT_ORDER,
        payload: res,
      });
    }
  } catch (error) { }
}

function* getSingleRepeatOrderWorker({ id }) {
  try {
    const res = yield call(getSingleRepeatOrder, id);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SINGLE_REPEAT_ORDER,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SINGLE_REPEAT_ORDER,
        payload: res,
      });
    }
  } catch (error) { }
}

function* getSearchRepeatOrderWorker({ id }) {
  try {
    const res = yield call(getSearchRepeatOrder, id);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SEARCH_REPEAT_ORDER,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SEARCH_REPEAT_ORDER,
        payload: res,
      });
    }
  } catch (error) { }
}

function* updateRepeatOrderDateWorker({ payload, id, status, actiontype }) {
  try {
    const res = yield call(updateDateAPI, payload, id, status, actiontype);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_REPEAT_ORDER_DATE,
        payload: res,
        requestPayload: payload,
      });
      yield put({
        type: SUCCESS_STATUS_PATIENT_UPDATE,
        payload: {
          status: status,
          patient_id: id,
          update_type: actiontype,
        },
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Date Updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_REPEAT_ORDER_DATE,
        payload: res,
      });
    }
  } catch (error) { }
}

function* updateGlobalSettingWorker({ payload, actionType }) {
  try {
    const res = yield call(updateGlobalSettingAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_UPDATE_GLOBAL_SETTING,
        payload: res?.data ? res.data : {},
        actionType,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Global setting updated Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_GLOBAL_SETTING,
        payload: res,
      });
    }
  } catch (error) { }
}

function* getPrintRepeatOrderListWorker({ payload }) {
  try {
    const res = yield call(getRepeatOrderListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_PRINT_REPEAT_ORDER_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_PRINT_REPEAT_ORDER_LIST,
        payload: res,
      });
    }
  } catch (error) { }
}

function* updateRepeatOrderNoteWorker({ id, payload }) {
  try {
    const res = yield call(updateRepeatOrderNoteAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_REPEAT_ORDER_NOTE,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Order note updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_REPEAT_ORDER_NOTE,
        payload: res,
      });
    }
  } catch (error) { }
}

function* deleteRepeatOrderNoteWorker({ id }) {
  try {
    const res = yield call(deleteRepeatOrderNoteAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_REPEAT_ORDER_NOTE,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Order Note deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_REPEAT_ORDER_NOTE,
        payload: res,
      });
    }
  } catch (error) { }
}

function* getOSSOrderListWorker({ payload }) {
  try {
    const res = yield call(getOosOrderListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_OOS_ORDER,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_OOS_ORDER,
        payload: res,
      });
    }
  } catch (error) { }
}

function* globalSettingAccessWorker() {
  try {
    const res = yield call(globalSettingAccessApi);
    if (res.success) {
      yield put({
        type: SUCCESS_GLOBAL_SETTING_ACCESS,
        payload: res?.data ? res.data : [],
      });
    } else {
      yield put({
        type: ERROR_GLOBAL_SETTING_ACCESS,
        payload: res,
      });
    }
  } catch (error) { }
}
function* globalSettingWorker() {
  try {
    const res = yield call(globalSettingAPI);
    if (res.success) {
      yield put({
        type: SUCCESS_GLOBAL_SETTING,
        payload: res?.data ? res.data : [],
      });
    } else {
      yield put({
        type: ERROR_GLOBAL_SETTING,
        payload: res,
      });
    }
  } catch (error) { }
}

function* createMultiOrderWorker({ payload }) {
  try {
    const res = yield call(createMultiOrderAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_MULTI_ORDER,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Order Create Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_MULTI_ORDER,
        payload: res,
      });
    }
  } catch (error) { }
}
function* patientMultiOrderWorker({ payload }) {
  try {
    const res = yield call(patientMultiOrderAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_PATIENT_MULTI_ORDER,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Order Create Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_PATIENT_MULTI_ORDER,
        payload: res,
      });
    }
  } catch (error) { }
}
function* nextOrderCycleWorker({ payload }) {
  try {
    const res = yield call(nextOrderCycleAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_NEXT_ORDER_CYCLE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Next Order Date Created Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_NEXT_ORDER_CYCLE,
        payload: res,
      });
    }
  } catch (error) { }
}

function* getPrnWorker({ payload }) {
  try {
    const res = yield call(updatePRNAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_PRN_DRUG,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_PRN_DRUG,
        payload: res,
      });
    }
  } catch (error) { }
}
function* getorderCountTypeWorker({ payload }) {
  try {
    const res = yield call(orderCountTypeAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_ORDER_COUNT_TYPE,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_ORDER_COUNT_TYPE,
        payload: res,
      });
    }
  } catch (error) { }
}

function* getTotalBulkOrderCount({ payload }) {
  try {
    const res = yield call(bulkOrderCountAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_BULK_ORDER_COUNT,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_BULK_ORDER_COUNT,
        payload: res,
      });
    }
  } catch (error) { }
}

function* getTotalBulkOrderList({ payload }) {
  try {
    const res = yield call(getBulkOrderListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_BULK_ORDER_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_BULK_ORDER_LIST,
        payload: res,
      });
    }
  } catch (error) { }
}

function* createBulkOrderWorker({ payload }) {
  try {
    const res = yield call(createBulkOrderAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_CREATE_BULK_ORDERS,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Please wait a few minutes, then refresh the page to view the updated order list.",
          type: "success",
        },
      })
    } else {
      yield put({
        type: ERROR_CREATE_BULK_ORDERS,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Failed to create order",
          type: "error",
        },
      });
    }
  } catch (error) { }
}

export function* ReaeatOrderSaga() {
  yield takeLatest(START_GET_REPEAT_ORDER_LIST, getRepeatOrderListWorker);
  // yield takeEvery(START_GET_REPEAT_ORDER_LIST, getRepeatOrderListWorker);
  yield takeEvery(START_DELETE_REPEAT_ORDER, deleteRepeatOrderWorker);
  yield takeEvery(
    START_REPEAT_ORDER_PATIENT_FIELD_LIST,
    getRepeatOrderPatientFieldListWorker
  );
  yield takeEvery(START_CREATE_REPEAT_ORDER, createRepeatOrderWorker);
  yield takeEvery(START_UPDATE_REPEAT_ORDER, updateRepeatOrderWorker);
  yield takeEvery(START_GET_SINGLE_REPEAT_ORDER, getSingleRepeatOrderWorker);
  yield takeEvery(START_GET_SEARCH_REPEAT_ORDER, getSearchRepeatOrderWorker);
  yield takeEvery(START_UPDATE_REPEAT_ORDER_DATE, updateRepeatOrderDateWorker);
  yield takeEvery(START_UPDATE_GLOBAL_SETTING, updateGlobalSettingWorker);
  yield takeEvery(
    START_GET_PRINT_REPEAT_ORDER_LIST,
    getPrintRepeatOrderListWorker
  );
  yield takeEvery(START_UPDATE_REPEAT_ORDER_NOTE, updateRepeatOrderNoteWorker);
  yield takeEvery(START_DELETE_REPEAT_ORDER_NOTE, deleteRepeatOrderNoteWorker);
  yield takeEvery(START_GET_OOS_ORDER, getOSSOrderListWorker);
  yield takeEvery(START_GLOBAL_SETTING, globalSettingWorker);
  yield takeEvery(START_CREATE_MULTI_ORDER, createMultiOrderWorker);
  yield takeEvery(START_PRN_DRUG, getPrnWorker);
  yield takeEvery(START_PATIENT_MULTI_ORDER, patientMultiOrderWorker);
  yield takeEvery(START_GLOBAL_SETTING_ACCESS, globalSettingAccessWorker);
  yield takeEvery(START_NEXT_ORDER_CYCLE, nextOrderCycleWorker);
  yield takeEvery(START_ORDER_COUNT_TYPE, getorderCountTypeWorker);
  yield takeEvery(START_BULK_ORDER_COUNT, getTotalBulkOrderCount);
  yield takeEvery(START_GET_BULK_ORDER_LIST, getTotalBulkOrderList);
  yield takeEvery(START_CREATE_BULK_ORDERS, createBulkOrderWorker);
}
